<div class="container">
  <div class="header">
    <div class="header-left">
      <button mat-flat-button color="accent" (click)="queryTransactions()">Query Transactions</button>

      <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="" #filter>
      </mat-form-field>
    </div>

    <div class="header-right">
      <div class="loading-status" *ngIf="loadingTransactions">
        <span class="loading-label">Loading Transactions</span>
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
      </div>
    </div>
  </div>

  <div class="transaction-sums">
    <div class="transaction-sums-item" *ngFor="let item of sums">
      <div class="transaction-sums-item-label">{{ item.type }}s</div>
      <div class="transaction-sums-item-value">{{ item.totalAmount | currency }}</div>
    </div>
  </div>

  <div class="table-shadow">
    <div class="transaction-table">
      <mat-table class="transaction-table" [dataSource]="source" matSort matSortActive="merchantID" matSortDirection="desc">
        <ng-container [matColumnDef]="def.field" *ngFor="let def of colDefs">
          <mat-header-cell *matHeaderCellDef mat-sort-header [sortActionDescription]="'Sort by ' + def.header">
            <div class="table-header">{{ def.header }}</div>
          </mat-header-cell>

          <mat-cell *matCellDef="let element">
            <input readonly
                *ngIf="def.format == undefined"
                [value]="element[def.field]">
            <input readonly
                *ngIf="def.format == 'titlecase'"
                [value]="element[def.field] | titlecase">
            <input  readonly
                *ngIf="def.format == 'currency'"
                [value]="element[def.field] | currency">
            <input  readonly
                *ngIf="def.format == 'date'"
                [value]="element[def.field] | date: 'mediumDate'">
            <input readonly
                *ngIf="def.format == 'phone'"
                [value]="element[def.field] | phone">
            <mat-button-toggle-group aria-label="Actions" hideSingleSelectionIndicator="true" *ngIf="def.format == 'actions'">
            </mat-button-toggle-group>        
          </mat-cell>

        </ng-container>

        <mat-header-row *matHeaderRowDef="this.displayedCols"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols;"></mat-row>

        <!-- theoretically should work but angular doesn't like it
        <mat-row *matNoDataRow>
          <mat-cell [attr.colspan]="colDefs.length">No data matching the filter "{{filter.value}}"</mat-cell>
        </mat-row>
        -->
      </mat-table>
    </div>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of suppliers"></mat-paginator>
  </div>
</div>